import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { RadioGroup } from '../Radio';
import CardWithCheckbox from './CardWithCheckbox';
import { formatAddressInTwoLines, getAllAddressesMappedByType } from '../../services/addresses';

const CardWithCheckboxDemo = () => {
  const val = '';
  const [value, setValue] = useState<string | number>(val);
  const addresses = getAllAddressesMappedByType();

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  const [workAddress1, workAddress2] = formatAddressInTwoLines(addresses.work[0]);
  const [altAddress1, altAddress2] = formatAddressInTwoLines(addresses.alt[0]);

  const cardData = [
    {
      mailLocation: 'Work',
      address: workAddress1,
      city: workAddress2,
      id: 'Work',
    },
    {
      mailLocation: 'Alternate',
      address: altAddress1,
      city: altAddress2,
      id: 'Alternate',
    },
  ];

  return (
    <Container>
      <h4 className={'mb-10'}>Checkbox With Image</h4>
      <Row className={'d-flex flex-column flex-lg-row'}>
        <RadioGroup name={'test'} value={value} onChange={handleChange}>
          {cardData.map((data) => {
            return (
              <Col className={'col-12 mb-2'}>
                <CardWithCheckbox
                  selected={value === data.id}
                  cardData={data}
                />
              </Col>
            );
          })}
          <Col className={'col-12 mb-2'}>
            <CardWithCheckbox
              selected={value === cardData[0].id}
              cardData={cardData[0]}
              variant='white-background'
            />
          </Col>
        </RadioGroup>
      </Row>
    </Container>
  );
};

export default CardWithCheckboxDemo;
